define('models/targetingDimension',["T1", "T1Model", "Backbone"], function (T1, T1Model, Backbone) {
  T1.Models.TargetingDimension = T1Model.extend({
    canCache: true,
    url: "targeting_dimensions"
  });
  return T1.Models.TargetingDimension;
});
